import { Stack } from '@amboss/design-system';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { config } from '../../../../config';
import useCreditsPaginate from '../../../../hooks/useCreditsPaginate';
import EmptyPlaceholder from '../../../atoms/EmptyPlaceholder';
import ClaimedList from '../lists/ClaimedList';

const ClaimedTab = () => {
  const { t } = useTranslation();
  const { isLoading, credits, refreshCredits } = useCreditsPaginate(config.tabs.CLAIMED);

  useEffect(() => {
    refreshCredits();
  }, []);

  return (
    <>
      {!isLoading && (
        <Stack space={'m'}>
          {credits?.items && credits.items.length > 0 ? (
            <ClaimedList credits={credits} />
          ) : (
            <EmptyPlaceholder
              header={t('credits.tabs.tab3.emptyPlaceholder.header')}
              subHeader={t('credits.tabs.tab3.emptyPlaceholder.subHeader')}
            />
          )}
        </Stack>
      )}

      {isLoading && (
        <Stack space={'m'}>
          <EmptyPlaceholder
            header={t('loading.header')}
            subHeader={t('loading.subheader')}
          />
        </Stack>
      )}
    </>
  );
};

export default ClaimedTab;
